import * as React from 'react';
import c from 'classnames';

import { CalendarItem } from '../../types';
import ListItem from './Item';

import './style.scss';

interface Props {
  items: CalendarItem[],
  ariaLabelledBy?: string,
}

const List: React.FC<Props> = ({ items, ariaLabelledBy }) => {
  const classNames = c('CalendarWidget__List');

  return (
    <ol className={classNames} aria-labelledby={ariaLabelledBy}>
      {items.map((item, index) => {
        return (
          <li key={`${item.date}:${index + 1}`}>
            <ListItem {...item} />
          </li>
        );
      })}
    </ol>
  );
};

export default List;
